import { render, staticRenderFns } from "./ProviderStreamsComparatorBar.vue?vue&type=template&id=670bb08a&scoped=true"
import script from "./ProviderStreamsComparatorBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderStreamsComparatorBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderStreamsComparatorBar.vue?vue&type=style&index=0&id=670bb08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670bb08a",
  null
  
)

export default component.exports